import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { Container } from "../Container";
export const CollectionJumboWrapper = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("header", {
        className: `jumbotron jumbotron--large jumbotron--default jumbotron--collection-item`,
        children: /*#__PURE__*/ _jsx(Container, {
            className: "jumbotron__inner",
            children: /*#__PURE__*/ _jsx("div", {
                className: "jumbotron__content",
                children: children
            })
        })
    });
};
